import requestProps from './requestProps.js';
const model = {
    name: 'SearchRequest',
    file: 'SearchRequest',
    buildInterface: true,
    properties: {
        ...requestProps,
    },
};
export default model;
